import React from 'react';

const toneClasses = {
  primary: 'md-card-kpi-primary',
  dark: 'md-card-kpi-dark',
  warm: 'md-card-kpi-warm',
  slate: 'md-card-kpi-slate',
  secondary: 'md-card-kpi-slate',
  success: 'md-card-kpi-dark',
  warning: 'md-card-kpi-warm',
  danger: 'md-card-kpi-slate',
};

const KpiStatCard = ({ label, value, hint, icon: Icon, tone = 'primary' }) => (
  <div className={`md-card h-full ${toneClasses[tone] || toneClasses.primary}`}>
    <div className="md-card-body p-5 min-h-[120px] flex items-start gap-4">
      {Icon && (
        <div className="md-icon-well bg-white/15 text-white shadow-[inset_2px_2px_6px_rgba(0,0,0,0.2),inset_-2px_-2px_6px_rgba(255,255,255,0.12)] shrink-0">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <div className="min-w-0 pt-0.5">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-white/70 truncate mb-1">
          {label}
        </p>
        <p className="text-2xl font-bold text-white tracking-tight leading-none mb-0">{value}</p>
        {hint && <p className="text-xs text-white/60 mt-2 mb-0">{hint}</p>}
      </div>
    </div>
  </div>
);

export default KpiStatCard;
